import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H6, P } from "../../../../../AbstractElements";
import { ClipboardOnParagraphTitle, Copy } from "../../../../../Constants/Constants";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const ClipboardOnParagraph = () => {
  const clipboardParagraphText2: string = "On that day, hopes and dreams were crushed. Even though it should have been anticipated, it nonetheless surprised me. The warning indicators have been disregarded in favour of the slim chance that it would actually occur. From a hopeful prospect, it had evolved into an unquestionable conviction that it must be fate. That was up until it wasn't, at which point all of the aspirations and dreams collapsed.";
  const [clipBoardValues, setClipBoardValues] = useState(clipboardParagraphText2);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(clipBoardValues);
    setClipBoardValues(clipBoardValues);
  };
  return (
    <Col sm="12" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={ClipboardOnParagraphTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="f-16">{"Copy from paragraph"}</P>
            <H6 className="border rounded f-w-300">
              <CardBody>{clipboardParagraphText2}</CardBody>
            </H6>
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard" color="info" onClick={handleCopy}>
                <i className="fa fa-copy"></i> {Copy}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ClipboardOnParagraph;
